var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from 'react';
import { useLDClient } from 'launchdarkly-react-client-sdk';
export var getUserFlagValue = function (ldUser, featureFlagName, defaultValue) {
    var ldClient = useLDClient();
    return new Promise(function (resolve, reject) {
        if (ldUser) {
            var user = {
                key: ldUser,
            };
            ldClient
                .identify(user)
                .then(function (valueFlags) {
                resolve(valueFlags[featureFlagName]);
            })
                .catch(function (reason) {
                reject(reason);
                return defaultValue;
            });
        }
    });
};
export var Component = function (props) {
    var featureFlagName = props.featureFlagName, defaultValue = props.defaultValue, ldUser = props.ldUser;
    var ldClient = useLDClient();
    var featureFlag = defaultValue;
    if (ldUser) {
        var user = {
            key: ldUser,
        };
        ldClient.identify(user);
    }
    featureFlag = ldUser == undefined ? false : ldClient === null || ldClient === void 0 ? void 0 : ldClient.variation(featureFlagName, defaultValue);
    return React.createElement(React.Fragment, null, featureFlag && props.children);
};
export function useFeatureFlagUser(featureFlag, key) {
    var _this = this;
    var ldClient = useLDClient();
    var _a = useState({
        isEnabled: false,
        isChecked: false,
        error: '',
    }), flagInfo = _a[0], setFlagInfo = _a[1];
    useEffect(function () {
        if (featureFlag && key && (ldClient === null || ldClient === void 0 ? void 0 : ldClient.identify)) {
            var setupFeatureFlags = function () { return __awaiter(_this, void 0, void 0, function () {
                var flags, enabled, err_1, error;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, ((_a = ldClient.identify) === null || _a === void 0 ? void 0 : _a.call(ldClient, {
                                    key: key,
                                }))];
                        case 1:
                            flags = _b.sent();
                            enabled = flags[featureFlag];
                            setFlagInfo(__assign(__assign({}, flagInfo), { isEnabled: enabled, isChecked: true }));
                            return [3 /*break*/, 3];
                        case 2:
                            err_1 = _b.sent();
                            error = err_1.message;
                            setFlagInfo(__assign(__assign({}, flagInfo), { isChecked: true, error: error }));
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            }); };
            setupFeatureFlags();
            // cleanup
            return function () {
                setFlagInfo({
                    isEnabled: false,
                    isChecked: false,
                    error: '',
                });
            };
        }
    }, [featureFlag, key, ldClient === null || ldClient === void 0 ? void 0 : ldClient.identify]);
    return flagInfo;
}
export function useAllFeatureFlagsUser(key) {
    var _this = this;
    var ldClient = useLDClient();
    var _a = useState({
        error: '',
        featureFlags: null,
        isChecked: false,
    }), value = _a[0], setValue = _a[1];
    useEffect(function () {
        if (key && (ldClient === null || ldClient === void 0 ? void 0 : ldClient.identify)) {
            var setupFeatureFlags = function () { return __awaiter(_this, void 0, void 0, function () {
                var flags, err_2, error;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, ((_a = ldClient.identify) === null || _a === void 0 ? void 0 : _a.call(ldClient, {
                                    key: key,
                                }))];
                        case 1:
                            flags = _b.sent();
                            setValue(__assign(__assign({}, value), { featureFlags: flags, isChecked: true }));
                            return [3 /*break*/, 3];
                        case 2:
                            err_2 = _b.sent();
                            error = err_2.message;
                            setValue(__assign(__assign({}, value), { isChecked: true, error: error }));
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            }); };
            setupFeatureFlags();
            // cleanup
            return function () {
                setValue({
                    error: '',
                    featureFlags: null,
                    isChecked: false,
                });
            };
        }
    }, [key, ldClient === null || ldClient === void 0 ? void 0 : ldClient.identify]);
    return value;
}
//# sourceMappingURL=FeatureFlagUser.js.map